import ArrowDropDown from '@material-ui/icons/ArrowDropDown';
import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { Button } from '../Button';
import { Menu } from './Menu';
import { genericMenuButtonStyles, menuButtonArrowDown } from './styled';

const StyledButton = styled(Button)`
  ${genericMenuButtonStyles}

  & .menu-button__arrow-drop-down {
    ${menuButtonArrowDown}
  }
`;

const IconContainer = styled.div`
  display: inline-flex;
  flex-shrink: 0;
`;

type MenuButtonProps = Omit<
  React.ComponentProps<typeof Menu>,
  'buttonElement'
> &
  Partial<Pick<React.ComponentProps<typeof Button>, 'variant'>> & {
    className?: string;
    icon?: ReactNode;
    buttonRef?: React.Ref<HTMLButtonElement>;
    label: React.ReactNode;
  };

export function MenuButton({
  className,
  icon,
  label,
  options,
  variant,
  buttonRef,
  ...rest
}: MenuButtonProps) {
  return (
    <Menu
      buttonElement={
        <StyledButton
          className={className}
          color="primary"
          variant={variant || 'contained'}
          ref={buttonRef}
        >
          {icon && <IconContainer aria-hidden>{icon}</IconContainer>}
          {label}
          <ArrowDropDown aria-hidden className="menu-button__arrow-drop-down" />
        </StyledButton>
      }
      options={options}
      {...rest}
    />
  );
}
